import TaxiCorporationAddRequest, {
  TaxiCorporationAddRequestContractMaintenancePolicy,
} from "../../../api/raily/taxi-corporation/add/taxi-corporation-add-request";
import ContractMaintenancePolicy from "../../../types/contract-maintenance-policy";
import TaxiCorporationAddParams from "./taxi-corporation-add-params";

const createContractMaintenancePolicy = (
  contractMaintenancePolicy: ContractMaintenancePolicy,
): TaxiCorporationAddRequestContractMaintenancePolicy => {
  switch (contractMaintenancePolicy) {
    case ContractMaintenancePolicy.BASIC:
      return TaxiCorporationAddRequestContractMaintenancePolicy.BASIC;
    case ContractMaintenancePolicy.AUCTION:
      return TaxiCorporationAddRequestContractMaintenancePolicy.AUCTION;
  }
};

const create = (
  params: TaxiCorporationAddParams,
): TaxiCorporationAddRequest => {
  return {
    taxId: params.taxId,
    regon: params.regon,
    krsNo: params.krsNo,
    companyName: params.companyName,
    displayName: params.displayName,
    headquartersAddressString: params.headquartersAddressString,
    contractMaintenancePolicy: createContractMaintenancePolicy(
      params.contractMaintenancePolicy,
    ),
    notes: params.notes,
  };
};

const taxiCorporationAddParamsFactory = {
  create,
};

export default taxiCorporationAddParamsFactory;
